import type { Resource } from '../../';
export const general_addToWishList: Resource = {"default":"Add To Wishlist"};
